import { createContext, useEffect, useState } from "react";
import { Button, Col, Row, Card, Container } from "react-bootstrap";
import { useParams } from "react-router-dom";
import useBCALogic from "./hooks/useBCALogic";
import Loader2 from "../../../components/Loader2";
import BatchClassDetails from "./components/BatchClassDetails";
import BatchStudentsTable from "./components/BatchStudentsTable";
import Signature from "../CommonComponents/Signature/Signature.jsx";

export const BcaViewContext = createContext(null);

export default function BcaView() {
    const { id } = useParams();

    const context = useBCALogic(id);

    const { batchData, isLoadingResources, downloadPdf } = context ?? {};

    const [payLoad, setPayload] = useState(null);

    useEffect(() => {
        console.log("Saved Signature state:", payLoad);
    }, [payLoad]);

    if (isLoadingResources) return <Loader2 />;
    return (
        <BcaViewContext.Provider value={context}>
            <Container fluid className="">
                <Row>
                    <Col md={12}>
                        <h3 className="m-0 p-0 fw-bolder">
                            Class - Student Attendance
                        </h3>
                    </Col>
                </Row>
                <Row className="g-3">
                    {/* Card A */}
                    <BatchClassDetails batchData={batchData?.batch ?? []} />

                    {/* Card B */}
                    <Col xxl={8}>
                        <BatchStudentsTable
                            students={batchData?.batch?.batch_students ?? []}
                        />
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col md={12} className="d-flex justify-content-end gap-2">
                        <Button
                            onClick={() => downloadPdf("Attendance.pdf", true)}
                        >
                            With Result Excel
                        </Button>

                        <Button
                            onClick={() => downloadPdf("Attendance.pdf", false)}
                        >
                            Export Excel
                        </Button>
                    </Col>
                </Row>
            </Container>
        </BcaViewContext.Provider>
    );
}
